<template>
    <div class=''>
        <!-- <a-spin :spinning="spinning" class="spin-box" :tip="$t('spin.text')"> -->
            <!-- <v-form
                :ref="defaultActiveKey == 0 ? 'hardwareForm' : 'unbindForm'"
                v-model="valid"
                :class="dataType ? '' : 'formStyle'"
                class="form-box"> -->
                <template v-if="dataType">
                    <v-tabs v-model="tab"  centered   class="tabs-box" size="large" :activeKey="defaultActiveKey" @change="tabsChange" >
                        <v-tab key="0" style="color: #5066e0;caret-color: #5066e0;">{{$t('account.hardware.bind')}}</v-tab>
                        <v-tab key="1" style="color: #5066e0;caret-color: #5066e0;">{{$t('account.hardware.unbindTabs')}}</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="defaultActiveKey">
                        <v-tab-item :key="0">
                                    <v-form
                                        class="device-box mb-6"
                                        ref="hardwareForm"
                                    >
                                        <v-text-field
                                            v-model="form.num"
                                            outlined
                                            required
                                            dense
                                            :label="$t('account.hardware.num')"
                                            :placeholder="$t('account.hardware.numPlaceholder')"
                                            hide-details="auto"
                                            :rules="hardwareFormRule.num"
                                            class="mb-6"
                                        ></v-text-field>
                                        <v-text-field
                                            v-model="form.code"
                                            outlined
                                            required
                                            dense
                                            :label="$t('account.hardware.code')"
                                            :placeholder="$t('account.hardware.codePlaceholder')"
                                            hide-details="auto"
                                            :rules="hardwareFormRule.code"
                                            class="mb-8"
                                        ></v-text-field>
                                        <div class="btn-box">
                                            <v-btn small color="primary"   @click="bindFun">{{$t('btn.submit')}}</v-btn>
                                            <v-btn small outlined class="close_btn"  @click="close">{{$t('btn.close')}}</v-btn>
                                        </div>
                                    </v-form>
                                    <div class="tab-box">

                                    </div>
                        </v-tab-item>
                        <v-tab-item :key="1">
                            <!-- <v-card class="d-flex flex-column cardStyle"> -->
                                <v-form
                                    class="device-box mb-6"
                                    ref="unbindForm">
                                    <!-- <v-col cols="12"> -->
                                        <v-select
                                            v-model="unbindForm.type"
                                            dense
                                            :rules="hardwareFormRule.type"
                                            :items="tokenList"
                                            item-value="key"
                                            item-text="value"
                                            :label="$t('account.hardware.num')"
                                            outlined
                                            clearable
                                            hide-details="auto"
                                            class="mb-6"
                                            :menu-props="{ bottom: true, offsetY: true }">
                                        </v-select>
                                    <!-- </v-col> -->
                                    <!-- <v-col cols="12"> -->
                                        <v-text-field
                                            outlined
                                            disabled
                                            dense
                                            :value="dataList.mobile"
                                            :label="$t('account.pghoess')"
                                            hide-details="auto"
                                            class="mb-6"
                                        ></v-text-field>
                                    <!-- </v-col> -->
                                    <!-- <v-col cols="12"> -->
                                        <v-row no-gutters class="mb-8">
                                            <v-col cols="8" md="8" lg="8" xl="8" sm="12 ">
                                                <v-text-field
                                                    v-model="unbindForm.unbindCode"
                                                    outlined
                                                    required
                                                    dense
                                                    :rules="hardwareFormRule.unbindCode"
                                                    :label="$t('account.code')"
                                                    :placeholder="$t('account.codePlaceholder')"
                                                    hide-details="auto"
                                                    class="code-btn"
                                                ></v-text-field>
                                            </v-col>
                                            <v-spacer></v-spacer>
                                            <v-col cols="3" md="3" lg="3" xl="3" sm="12" class="code-box  ml-1  d-flex justify-end align-baseline" :class="codeText == $t('account.getCode')?'cursor-pointer':'text'" @click="getCode">
                                                <v-btn small outlined v-if="codeText == $t('account.getCode')" color="primary" min-height="40" style="width:118%">{{codeText}}</v-btn>
                                                <v-btn small outlined v-else style="width:100%" disabled min-height="40">{{codeText+'s'}}</v-btn>
                                            </v-col>
                                        </v-row>
                                    <!-- </v-col> -->
                                    <div class="text-center" >
                                        <v-btn small color="primary" @click="onSubmit">{{$t('btn.submit')}}</v-btn>
                                        <v-btn small outlined class="close_btn" @click="close">{{$t('btn.close')}}</v-btn>
                                    </div>
                                </v-form>

                            <!-- </v-card> -->
                        </v-tab-item>
                    </v-tabs-items>
                </template>
                <template v-else>
                    <v-form
                        class="device-box mb-6"
                        ref="hardwareForm">
                        <v-text-field
                            v-model="form.num"
                            outlined
                            required
                            dense
                            :label="$t('account.hardware.num')"
                            :placeholder="$t('account.hardware.numPlaceholder')"
                            hide-details="auto"
                            :rules="hardwareFormRule.num"
                            class="mb-6"
                        ></v-text-field>
                        <v-text-field
                            v-model="form.code"
                            outlined
                            required
                            dense
                            :label="$t('account.hardware.code')"
                            :placeholder="$t('account.hardware.codePlaceholder')"
                            hide-details="auto"
                            :rules="hardwareFormRule.code"
                            class="mb-8"
                        ></v-text-field>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-btn small color="primary" @click="bindFun">{{$t('btn.submit')}}</v-btn>
                                <v-btn small class="close_btn" outlined @click="close">{{$t('btn.close')}}</v-btn>
                            </v-col>
                        </v-row>
                    </v-form>

                </template>

            <!-- </v-form> -->
        <!-- </a-spin> -->
    </div>
</template>

<script>

import { bindHardwareToken, unbindHardwareToken, getHardwareToken, smsReset } from "@/api/index";
import store from '@/store'
export default {
    data() {
        return {
            valid: false,
            form: {},
            tab: null,
            hardwareFormRule:
                {
                    num: [
                        v => !!v || this.$t('account.hardware.numPlaceholder'),
                    ],
                    code: [
                        v => !!v || this.$t('account.hardware.codePlaceholder'),

                    ],
                    unbindCode: [
                        v => !!v || this.$t('account.codePlaceholder'),
                        v => (/^[0-9]{6}$/.test(v)) || this.$t('account.code6')
                    ],
                    type: [
                        v => !!v || this.$t('account.typePlaceholder'),
                    ],
                },
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
            defaultActiveKey: "0",
            unbindForm: {},
            codeText: this.$t('account.getCode'),
            spinning: false,
            tokenList: []
        };
    },
    mounted() {
        this.$root.eventHub.$on('handleCancel7', ()=> {
            this.$refs.hardwareForm.resetValidation();
            this.$root.eventHub.$off("handleCancel7")
        })
    },
    created() {
        if (this.dataType) {
            this.getTokenList()
        }
    },
    props: {
        dataType: Boolean,
        dataList: Object
    },
    methods: {
        getTokenList() {
            getHardwareToken().then(res=> {
                if (res.code == this.$GLOBA.StatusOK) {
                    this.tokenList = res.data
                    this.$set(this.unbindForm, 'type', this.tokenList[0])
                }else{
                    store.dispatch('snackbar/openSnackbar',{
                        snackbarText: res.message,
                        colorType: 'error'
                    })
                }
            })
        },
        bindFun() {
            let self = this
            if(this.$refs.hardwareForm.validate()){
                let params = {
                    tokenSn: self.form.num,
                    otp: self.form.code
                }
                bindHardwareToken(params).then(res=> {
                    if (res.code == self.$GLOBA.StatusOK) {
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'success'
                        })
                        self.$emit("onSubmit")
                    } else {
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                    }
                })
            }else{
                return false
            }
        },
        onSubmit() {
            let self = this
            if(this.$refs.unbindForm.validate()){
                let params = {
                    code: self.unbindForm.unbindCode,
                    tokenSn: self.unbindForm.type
                }
                unbindHardwareToken(params).then(res=> {
                    if (res.code == self.$GLOBA.StatusOK) {
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'success'
                        })
                        self.$emit("onSubmit")
                    } else {
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                    }
                })
            }else{
                return false;
            }
        },
        close() {
            this.$emit("close")
        },
        tabsChange(e) {
            if(e == 1 && !this.dataList.mobile) {
                store.dispatch('snackbar/openSnackbar',{
                    snackbarText: this.$t('account.noPhone'),
                    colorType: 'error'
                })
                return;
            }
            this.defaultActiveKey = e
        },
        getCode() {
            if(this.codeText == this.$t('account.getCode')) {
                this.spinning = true
                let params = {
                    smsType: this.$getSmsModel('unbindOtp')
                }
                smsReset(params).then(res=> {
                    this.spinning = false
                    if (res.code == this.$GLOBA.StatusOK) {
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'success'
                        })
                        this.codeText = 60
                        let timer = setInterval(()=>{
                            this.codeText--
                            if(this.codeText <= 0) {
                                clearInterval(timer)
                                this.codeText = this.$t('account.getCode')
                            }
                        },1000)
                    }else{
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                    }
                }).catch(err=> {
                    this.spinning = false
                })
            }
        },
    },
}
</script>

<style lang='scss' scoped>
::v-deep .ant-input-group-addon {
    min-width: 93px;
    background: none;
}
.get-code {
    cursor: pointer;
    color: #5066e0;
}
.code-btn ::v-deep .ant-input {
    border-right: 0;
}
::v-deep{
    .ant-spin-container{
        // margin-top: -33px;
    }
    .ant-tabs-bar{
        border-bottom: 0;
    }
    .ant-tabs-nav-scroll{
        text-align: center;
    }
    .ant-tabs-nav .ant-tabs-tab-active{
        color: #5066e0;
        text-shadow: 0 0 0.25px currentColor;
    }
    .ant-tabs-ink-bar{
        background: #5066e0;
    }
    .ant-tabs-nav .ant-tabs-tab:hover{
        color: #5066e0;
    }
    .ant-form{
        // margin-top: 25px;
    }
    .formStyle{
        width: 70%;
        margin-left: 15%;
    }
    .cardStyle{
        width: 85%;
        margin-left: 7%;
        box-shadow: none !important;
    }
}
.v-application.theme--light .v-tabs:not(.v-tabs--vertical){
        box-shadow: none !important;
    }
.device-box {
    width: 75%;
    margin: 0 auto;
    padding-top: 20px;
}
::v-deep .row {
    align-items: start !important;
}
.close_btn{
    margin-left: 10px;
}
.code-box ::v-deep {
  .v-btn.theme--dark {
    border-color: rgba(231, 227, 252, 0.28) !important;
    .v-btn__content{
      color:rgba(231, 227, 252, 0.67);
    }
  }
}

@media screen and (min-width: 320px) and (max-width: 480px){
    .close_btn{
        margin-left: 6px;
    }
    ::v-deep {
        .v-text-field.v-text-field--enclosed .v-text-field__details{
            padding: 0;
        }
    }
    .device-box {
        width: 78%;
    }
}
</style>
